import CuttingPlanArt from "./CuttingPlanArt";

export default function Hero() {
  return (
    <section id="top" aria-labelledby="hero-title" className="m-hero">
      <div className="m-wrap m-hero-grid">
        <div className="m-anim-fade">
          <h1
            id="hero-title"
            style={{
              fontSize: "var(--m-fs-display)",
              fontWeight: 800,
              letterSpacing: "-0.035em",
              lineHeight: 1.02,
              margin: "0 0 0",
              color: "var(--m-fg)",
            }}
          >
            Every sheet<br />
            <span className="m-hero-line2">has a plan.</span>
          </h1>

          <p style={{ fontSize: "clamp(15px, 3.5vw, 18px)", lineHeight: 1.55, color: "var(--m-fg-mute)", margin: "20px 0 0", maxWidth: 500 }}>
            Track stock, cut sheets with the built-in optimizer, and issue GST invoices — from one system that speaks glass, not spreadsheets.
          </p>

          {/* Start free / login CTAs hidden for now — Nestify soft launch */}
          <div className="m-btn-row" style={{ marginTop: 28 }}>
            <a href="mailto:contact@glasssarthi.com" className="m-btn m-btn-ghost">Contact us</a>
          </div>
        </div>

        <div className="m-hero-art" style={{ display: "grid", placeItems: "center" }}>
          <CuttingPlanArt />
        </div>
      </div>

      <style>{`
        .m-hero-grid {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          gap: 40px;
          align-items: center;
        }
        @media (max-width: 900px) {
          .m-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .m-hero-art {
            display: grid !important;
            max-width: 400px;
            margin: 0 auto;
            width: 100%;
          }
        }
        @media (max-width: 480px) {
          .m-hero-art { max-width: 320px !important; }
        }
      `}</style>
    </section>
  );
}
